import { IPartitionedWorkoutFilters } from '../models/partitioned-workout-filters';
import { WorkoutFilters } from '../models/workout-filters';

export function partitionWorkoutFilters(
  workoutFilters: WorkoutFilters,
): IPartitionedWorkoutFilters {
  const initial: IPartitionedWorkoutFilters = {
    allowed: [],
    excluded: [],
    required: [],
  };
  if (!workoutFilters || !workoutFilters.length) {
    return initial;
  }
  if (typeof workoutFilters === 'string') {
    workoutFilters = workoutFilters.split(',');
  }
  return workoutFilters.reduce(
    (acc: IPartitionedWorkoutFilters, value: string) => {
      const trimmedValue = value.trim();
      if (trimmedValue) {
        if (trimmedValue.startsWith('+')) {
          acc.required.push(trimmedValue.substring(1));
          acc.allowed.push(trimmedValue.substring(1));
        } else if (trimmedValue.startsWith('-')) {
          acc.excluded.push(trimmedValue.substring(1));
        } else if (trimmedValue) {
          acc.allowed.push(trimmedValue);
        }
      }
      return acc;
    },
    initial,
  );
}
